import React from "react";
import {
  HostScreenQuestionItem as HostScreenQuestionItemCommonUi,
  QuestionItem,
  QuestionType,
} from "@lookiero/sty-psp-quiz-style-profile-common-ui";
import { HostScreenCta, HostScreenOnSuccessFunction } from "../hostScreenCta/HostScreenCta";

interface HostScreenQuestionItemHOCFunctionArgs {
  readonly onSuccess: HostScreenOnSuccessFunction;
}

interface HostScreenQuestionItemHOCFunction {
  (args: HostScreenQuestionItemHOCFunctionArgs): QuestionItem<QuestionType.HOST_SCREEN>;
}

const HostScreenQuestionItemHOC: HostScreenQuestionItemHOCFunction =
  ({ onSuccess }) =>
  ({ domain, country, question, level, children, tradename, segment }) => (
    <HostScreenQuestionItemCommonUi
      country={country}
      cta={<HostScreenCta question={question} onSuccess={onSuccess} />}
      domain={domain}
      level={level}
      question={question}
      questionParentId=""
      segment={segment}
      tradename={tradename}
    >
      {children}
    </HostScreenQuestionItemCommonUi>
  );

export { HostScreenQuestionItemHOC };
